// Supermove
import {Currency} from '@supermove/utils';

export type RefundPaymentFormType = {
  paymentId: number;
  name: string;
  amount: number | null;
  paymentMethodId: number;
  description?: string;
};

export type RefundPaymentFormToFormType = {
  paymentId: number;
  name: string;
  amount: string | null;
  paymentMethodId: number;
  description?: string;
};

const _new = ({
  paymentId,
  paymentMethodId,
}: {
  paymentId: number;
  paymentMethodId: number;
}): RefundPaymentFormType => ({
  paymentId,
  paymentMethodId,
  name: 'Refund',
  amount: null,
  description: '',
});

const toForm = ({
  paymentId,
  name,
  amount,
  paymentMethodId,
  description,
}: RefundPaymentFormType): RefundPaymentFormToFormType => ({
  paymentId,
  name,
  amount: Currency.toForm(amount),
  paymentMethodId,
  description,
});

const toMutation = ({
  paymentId,
  name,
  amount,
  paymentMethodId,
  description,
}: RefundPaymentFormToFormType) => ({
  paymentId,
  name,
  amount: Currency.toMutation(amount),
  paymentMethodId,
  description,
});

const RefundPaymentForm = {
  new: _new,
  toForm,
  toMutation,
};

export default RefundPaymentForm;
